<div class="header box flex justify-content-space-between position-relative flex-wrap" 
[class.uv-highlight]="uvHighlight">

    <div class="flex justify-content-center align-items-center">

        <span class="gray img-sm margin-right-sm margin-left-sm">
            <mat-icon>{{icon}}</mat-icon>
        </span>
        <h4>{{headerText}}</h4>

        <ng-content select="[left]"></ng-content>

    </div>

    <div class="flex flex-row justify-content-center align-items-center">

        <ng-content select="[right]"></ng-content>

    </div>

</div>
